<template>
  <ModalDialog :show="modalVisible" @closed="$emit('closed')" prevent-body-scroll>
    <template v-slot:title> Login to Mathsframe / Spellingframe </template>
    <template v-slot:default>
      <div class="sf-modal-body">
        <LoginForm
          :screen="screen"
          :login-mode="loginMode"
          @switchscreen="screen = $event"
          @closed="modalVisible = false"
          @loggedin="onLoggedin"
        />
        <div v-if="screen == 'sent'">
          <button
            type="button"
            @click="modalVisible = false"
            class="sf-btn-primary"
          >
            Close
          </button>
        </div>
      </div>
      <div clasS="sf-modal-footer">
        <div v-if="screen == 'login' && mfLoginActive" class="tw-text-xl tw-font-bold tw-mb-2">
          <a href="" v-if="loginMode == 'sf'" @click.prevent="loginMode = 'mf'">
            Log in with a Mathsframe username
          </a>
          <a href="" v-else @click.prevent="loginMode = 'sf'">
            Log in with a Spellingframe username
          </a>
        </div>
        <div v-if="screen != 'forgot' && screen !== 'sent'">
          <a href="" @click.prevent="screen = 'forgot'">
            Forgotten your login details?
          </a>
        </div>
        <div v-if="screen != 'login' && screen != 'loggedin'">
          <a href="" @click.prevent="screen = 'login'"> Back to login </a>
        </div>
        <div>
          Don't you have an account?&nbsp;
          <a href="/register"> Register here </a>
        </div>
      </div>
    </template>
  </ModalDialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ModalDialog from "../ui/ModalDialog.vue";
import LoginForm from "./LoginForm.vue";
import { SfLoginScreen } from "@/types/generalTypes";
import { isMathsAvailable } from "@/state/appState";

export default defineComponent({
  components: { ModalDialog, LoginForm },
  emits: ["closed"],
  data() {
    return {
      modalVisible: true,
      screen: "login" as SfLoginScreen,
      loginMode: "sf",
      mfLoginActive: false,
    };
  },
  computed: {
    mathsAvailable() {
      return isMathsAvailable('school', 'store');
    },
  },
  methods: {
    onLoggedin() {
      window.location.href = "/dashboard";
    }
  }
});
</script>
